import currency from 'currency.js'
import moment from 'moment'

const DEBUG = false

export default class discount_engine {

	// Important! also apply changes to BE
	static apply_cosm_discount(calculator, subtotal, discount, prods, delivery, cartQty) {
		const { conf = {} } = discount;
		if (!conf.PRODS) throw  new Error('The discount is not applicable to cosmetic products');

		if (!discount || !discount.enabled || !subtotal) throw new Error('Discount is invalid.');

		if (discount.expiry_date && moment(discount.expiry_date).isBefore(moment())) throw new Error('Discount is expired.');

		if (discount.max_use !== null) {
			if (discount.max_use_user && discount.userUsed >= discount.max_use)
				throw new Error(`This discount can only be used ${discount.max_use} time${discount.max_use != 1 ? 's' : ''}.`);
			else if (!discount.max_use_user && (discount.used || 0) >= discount.max_use)
				throw new Error(`Discount is expired.`);
		}

		if (discount?.recipient_orgs?.include?.length && !discount?.recipient_orgs?.include?.includes?.(app.user?.org?.oid))
			throw new Error('Discount is not applicable to this organisation.');

		const discountProds = discount.products?.include;
		if (discountProds?.length && !discountProds?.some?.((d) => prods.some((p) => p.pid === d))) {
			throw new Error('The discount is not applicable to these products.');
		}

		if (discount?.discount_from && subtotal.value < discount.discount_from) {
			throw new Error(`The discount can only be applied for orders above $${discount.discount_from}`);
		}

		let value = currency({
			free: () => subtotal.multiply(-1),
			dollar: () => currency(conf.amount).multiply(-1),
			percentage: () => { 
				if (!discountProds?.length) return subtotal.multiply(-conf.amount / 100);

				const discountProdsAmount = discountProds.reduce((acc, discountPid) => { 
					if (cartQty?.[discountPid]) {
						const { pid, price, conf } = prods.find((p) => p.pid === discountPid);
						acc =  acc.add(calculator.calculateProductPrice({
							pid, 
							qty: cartQty?.[discountPid], 
							price, 
							volumePrice: conf?.volume_price, 
							loyaltyPricing: conf?.loyalty_pricing 
						}).total);
					}
					return acc;
				}, currency(0));

				return discountProdsAmount.multiply(-conf.amount / 100).value;
			},
		}[conf.rule]?.() ?? 0);

		if (delivery && discount?.conf?.free_standard_shipping) {
			value = value.subtract(delivery);
		}

		return Math.abs(value.value) > subtotal.value ? subtotal.multiply(-1) : value;
	}
	
	static apply_discount({discount, items,subtotal,med,script_type}) {

		DEBUG && console.log("apply_discount()",{items,subtotal,med}, discount);
		let value = currency(0)
		if (discount) {
			if (discount.expiry_date && moment(discount.expiry_date).isBefore(moment()))
				throw new Error("Discount is expired.")
			if (discount.max_use!==null) {
				if (discount.max_use_user && discount.userUsed >= discount.max_use)
					throw new Error(`This discount can only be used ${discount.max_use} time${discount.max_use!=1?'s':''}.`)
				else if (!discount.max_use_user && (discount.used||0) >= discount.max_use)
					throw new Error(`This discount can only be used ${discount.max_use} time${discount.max_use!=1?'s':''}.`)
			} 
			if (discount.conf.new_user && !discount.isNewUser)
				throw new Error("Discount is only valid for new users.")
			if (!discount.isValidAge)
				throw new Error("Discount is not valid for your profile.")
			if (discount.orgs?.oid && app.runtime.partn_oid && discount.orgs.oid !== app.runtime.partn_oid)
				throw new Error("Discount is not applicable to this organisation.")
			if (!discount.isValidUser)
				throw new Error("Discount is not applicable.")
			if(["friend_referral", "reward_referral"].includes(discount?.type) && ['DocConsMHCP','DocConsMHCPCopay'].includes(med?.key))
				throw new Error("The discount is not applicable to this script.")
			if (items.find(({id}) => id === "EMPLOYEE_BENEFITS"))
				throw new Error("Discounts are not available with Employee Benefits")
			if (items.find(({id}) => id === "PARTNER_PAID"))
				throw new Error("Discounts are not available on consultations paid for by a partner")

			const { conf } = discount
			DEBUG && console.log("checking rule",conf.rule,conf);

			const checkForCatDisounts = (id) => conf[med?.itm_tp?.toUpperCase()] && ['MEDBUY', 'MEDCONS'].includes(id);
			const checkForReviewConsults = (id) => ["qualcons", "qualbuy", "qualclick"].includes(script_type) && ['MEDCONS'].includes(id) && conf.QUALCONS;

			// verify given discount is within the limits of the providing org even if no med was specified
			let restrictMeds = discount.meds?.include;
			if (!restrictMeds?.length && discount.orgs) {
				restrictMeds = app.runtime.org.conf?.disc_allow_meds;
			}
			if (restrictMeds?.length && med?.m && !restrictMeds?.includes(med?.m))
				throw new Error("The discount is not applicable to this script.")

			switch (conf.rule) {
				case "free": {
					const applicable = items.reduce((v,i)=>{
						if (
							conf[i.id] || 
							checkForCatDisounts(i.id) ||
							checkForReviewConsults(i.id) ||
							i.id === "EMPLOYEE_BENEFITS"
						) {
							i.discounted = i.price.multiply(-1)
							return v.subtract(i.price)
						}
						return v
					},currency(0))

					if (value.value === applicable.value)
						throw new Error("The discount is not applicable to this script.")
					value = applicable;	
					break;
				}
				case "dollar": {
					let amount = currency(conf.amount)
					const applicable = items.reduce((v,i)=>{
						if ((
								conf[i.id] ||  
								checkForCatDisounts(i.id) ||
								checkForReviewConsults(i.id)
							) && amount.intValue > 0
						) {
							const applicable = Math.min(amount.value,i.price.value)
							i.discounted = currency(applicable).multiply(-1)
							amount = amount.add(i.discounted)
							return v.add(i.discounted)
						}
						return v
					},currency(0))

					if (value.value === applicable.value)
						throw new Error("The discount is not applicable to this script.")
					value = applicable;
					break;
				}
				case "percentage": {
					const applicable = items.reduce((v,i)=>{
						if (
							conf[i.id] || 
							checkForCatDisounts(i.id) ||
							checkForReviewConsults(i.id)
						) {
							i.discounted = i.price.multiply(-conf.amount/100)
							return v.add(i.discounted)
						}
						return v
					},currency(0))

					if (value.value === applicable.value && discount.code!=='op')
						throw new Error("The discount is not applicable to this script.")
					value = applicable;
					break;
				}
			}
		}
		DEBUG && console.log("Final Discount", {value,items});
		return value
	}
	
	
}
